import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=c435e3a4&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"
import style0 from "./guide.vue?vue&type=style&index=0&id=c435e3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c435e3a4",
  null
  
)

export default component.exports